import { PacketIn } from "./PacketIn.js";
import { InboundPacketType } from "./InboundPacketType.js";
import type { MessageIOContext } from "../../../api/MessageIOContext.js";
import type { QueueState } from "../../queue/QueueState.js";
import { readJsonQueueState } from "../../queue/QueueState.js";


export class PacketInQueueState extends PacketIn {
    public queueState: QueueState | null = null;

    constructor() {
        super(InboundPacketType.QUEUE_STATE);
    }

    getQueueState(): QueueState {
        if (this.queueState === null)
            throw new Error("Packet has not been read yet");

        return this.queueState;
    }

    override readContents(
        _context: MessageIOContext,
        json: Record<string, any>,
    ): void {
        this.queueState = readJsonQueueState(json);
    }
}
